import { ArrowUpRight, Instagram } from "lucide-react";
import Reveal from "@/components/Reveal";
import { scrollToSection } from "@/components/SmoothScroll";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="footer" className="border-t border-white/5 bg-[#050505]">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-24">
        <Reveal>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 pb-14 border-b border-white/5">
            <img
              src="/logo-full.png"
              alt="Southline Creative — Websites, Business Cards, Leaflets"
              className="h-32 md:h-44 w-auto object-contain"
            />
            <button
              data-testid="footer-cta-button"
              onClick={() => scrollToSection("contact")}
              className="group inline-flex items-center gap-3 text-sm uppercase tracking-[0.25em] text-gold hover:text-gold-soft transition-colors duration-300 w-fit"
            >
              Start a project
              <span className="flex items-center justify-center w-10 h-10 border border-gold/40 group-hover:bg-gold group-hover:text-ink transition-colors duration-300">
                <ArrowUpRight className="w-4 h-4" />
              </span>
            </button>
          </div>
        </Reveal>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 py-14">
          <div className="col-span-2 md:col-span-2">
            <p className="text-sm text-cream/50 font-light leading-relaxed max-w-xs">
              An independent design studio crafting websites, business cards
              and leaflets for businesses that refuse to blend in.
            </p>
          </div>
          <div>
            <p className="eyebrow text-[10px] mb-5">Services</p>
            <ul className="space-y-3 text-sm text-cream/60">
              {["Websites", "Business Cards", "Leaflets & Flyers"].map((s) => (
                <li key={s}>
                  <button data-testid={`footer-service-${s.toLowerCase().replace(/[^a-z]+/g, "-")}`} onClick={() => scrollToSection("services")} className="hover:text-gold transition-colors duration-300">
                    {s}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="eyebrow text-[10px] mb-5">Studio</p>
            <ul className="space-y-3 text-sm text-cream/60">
              {[
                { label: "Work", id: "work" },
                { label: "Process", id: "process" },
                { label: "Contact", id: "contact" },
              ].map((l) => (
                <li key={l.id}>
                  <button data-testid={`footer-link-${l.id}`} onClick={() => scrollToSection(l.id)} className="hover:text-gold transition-colors duration-300">
                    {l.label}
                  </button>
                </li>
              ))}
              <li className="flex items-center gap-4 pt-2">
                <a
                  href="https://www.instagram.com/southline_creative"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-social-instagram"
                  aria-label="Southline Creative on Instagram"
                  className="text-cream/40 hover:text-gold transition-colors duration-300"
                >
                  <Instagram className="w-4 h-4" />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 pt-8 border-t border-white/5">
          <p className="text-xs text-cream/35 tracking-wide">© {year} Southline Creative. All rights reserved.</p>
          <p className="text-xs text-cream/35 tracking-[0.2em] uppercase">Websites · Business Cards · Leaflets</p>
        </div>
      </div>
    </footer>
  );
}
